import { observer } from 'mobx-react-lite';
import { type ReactNode, useEffect } from 'react';
import type { AdminPermission } from '@/auth/permissions';
import { authStore } from '@/stores';
import { Empty } from './Empty';

interface RequirePermissionProps {
  permission: AdminPermission;
  children: ReactNode;
}

export const RequirePermission = observer(
  ({ permission, children }: RequirePermissionProps) => {
    useEffect(() => {
      void authStore.checkAdminAccess(true);
    }, []);

    if (authStore.adminAccessChecking) {
      return (
        <div className="rounded-lg border border-border bg-white p-8 text-center text-sm text-muted-foreground shadow-sm">
          正在刷新页面权限...
        </div>
      );
    }

    if (!authStore.can(permission)) {
      return (
        <div className="rounded-lg border border-border bg-white p-8 shadow-sm">
          <Empty description="当前账号没有访问该页面的权限，请联系管理员开通。" />
        </div>
      );
    }

    return <>{children}</>;
  },
);
